import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import PageLayout from '../components/layout/PageLayout';
import FreeItemCreateForm from '../components/free/FreeItemCreateForm';
import SocietyContextMobileNav from '../components/societies/SocietyContextMobileNav';

const FreeItemCreatePage = () => {
  const { societySlug } = useParams();

  return (
    <PageLayout title="PakPoints">
      <Helmet>
        <title>Post Free Item - PakPoints</title>
        <meta name="description" content="Post a free item or exchange item in your society" />
      </Helmet>

      <div className="min-h-screen bg-gray-50">
        {societySlug ? (
          <SocietyContextMobileNav societySlug={societySlug} activeSection="free-items" />
        ) : null}
        <div className="py-8">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <FreeItemCreateForm />
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default FreeItemCreatePage;
